"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ViewWithImageBackground_1 = __importDefault(require("../../../ViewWithImageBackground"));
const ControlRendererContext_1 = __importDefault(require("../../../../../ControlRendererContext"));
const __1 = __importDefault(require("../../../.."));
const constants_1 = require("../../../../../constants");
const controlStyleToAtomStyle_1 = __importDefault(require("../../../../../shared/controlStyleToAtomStyle"));
const PageRendererWrapper = ({ page, children, }) => {
    const { Render, dimentions, getColorFromSpecification, globalFontSize, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const { style } = page;
    const pageStyles = (0, react_1.useMemo)(() => ({
        flexDirection: (style === null || style === void 0 ? void 0 : style.flexDirection) || 'column',
        justifyContent: style === null || style === void 0 ? void 0 : style.justifyContent,
        alignItems: style === null || style === void 0 ? void 0 : style.alignItems,
        paddingBottom: style === null || style === void 0 ? void 0 : style.paddingBottom,
        paddingLeft: style === null || style === void 0 ? void 0 : style.paddingLeft,
        paddingRight: style === null || style === void 0 ? void 0 : style.paddingRight,
        paddingTop: style === null || style === void 0 ? void 0 : style.paddingTop,
        backgroundColor: style === null || style === void 0 ? void 0 : style.background,
        width: constants_1.ONE_HUNDRED_PERCENT_COMPLEX_UNIT,
        flex: 1,
        height: constants_1.ONE_HUNDRED_PERCENT_COMPLEX_UNIT,
    }), [style]);
    const platform = processor.root.platformOS;
    const withChildrenWrapperStyle = (0, react_1.useMemo)(() => {
        const formatted = Object.assign(Object.assign({}, pageStyles), { flexGrow: 1, height: constants_1.ONE_HUNDRED_PERCENT_COMPLEX_UNIT });
        return formatted;
    }, [pageStyles]);
    const pageComputedStyle = (0, controlStyleToAtomStyle_1.default)({
        getColorFromSpecification,
        globalFontSize,
        style: pageStyles,
    });
    const { topNavigationBar } = page;
    let behavior = 'padding';
    let keyboardVerticalOffset;
    if (platform !== 'ios') {
        behavior = 'height';
        if (page.statusBarHidden) {
            const screenHeight = dimentions.screen.height;
            const windowHeight = dimentions.window.height;
            const virtualButtonsHeight = screenHeight - windowHeight;
            keyboardVerticalOffset = virtualButtonsHeight;
        }
        else {
            keyboardVerticalOffset = dimentions.statusBarHeight;
        }
    }
    return (react_1.default.createElement(Render.KeyboardAvoidingView, { style: {
            flex: 1,
            width: '100%',
            backgroundColor: pageComputedStyle.backgroundColor,
            maxHeight: '100%',
        }, behavior: behavior, enabled: !!page.avoidKeboard, keyboardVerticalOffset: keyboardVerticalOffset },
        topNavigationBar && topNavigationBar.active && (react_1.default.createElement(__1.default, { control: topNavigationBar, parent: page })),
        react_1.default.createElement(ViewWithImageBackground_1.default, { containerControlStyle: withChildrenWrapperStyle, resizeMode: page.resizeMode || undefined, backgroundImage: page.backgroundImage }, children)));
};
exports.default = PageRendererWrapper;
